module.exports = __webpack_public_path__ + "img/logo_5_tv.39cdcd08.svg";